import script from "./GiftReply.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftReply.vue?vue&type=script&setup=true&lang=js"

import "./GiftReply.vue?vue&type=style&index=0&id=ec93fbe4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec93fbe4"]])

export default __exports__